import React from 'react';
import { ContainerBackground, ContainerModal, BodyModal } from './styled';

interface Props {
  component?: React.FC;
  isVisible: boolean;
  children: React.ReactNode;
}

const NewModal: React.FC<Props> = ({ children, isVisible }) => {
  return (
    <>
      <ContainerBackground isVisible={isVisible} />
      <ContainerModal isVisible={isVisible}>
        <BodyModal>{children}</BodyModal>
      </ContainerModal>
    </>
  );
};

export default NewModal;
